import Vue from 'vue';
import VueCookies from 'vue-cookies';
import { KEYS, LIGHTBOX_CHECKOUT_TYPE } from '@/utils/constants';
// Registro de Cookies
Vue.use(VueCookies);
export const state = {
    [KEYS.MEETING]: Vue.$cookies.get(KEYS.MEETING) != undefined ? Vue.$cookies.get(KEYS.MEETING) : '',
    [KEYS.LIGHTBOX_CHECKOUT_TYPE]:
        Vue.$cookies.get(KEYS.LIGHTBOX_CHECKOUT_TYPE) != undefined ? Vue.$cookies.get(KEYS.LIGHTBOX_CHECKOUT_TYPE) : '',
    [KEYS.QUOTATION_TOKEN]:
        Vue.$cookies.get(KEYS.QUOTATION_TOKEN) != undefined ? Vue.$cookies.get(KEYS.QUOTATION_TOKEN) : '',
    [KEYS.SLOT_ID]: Vue.$cookies.get(KEYS.SLOT_ID) != undefined ? Vue.$cookies.get(KEYS.SLOT_ID) : '',
    [KEYS.CONTACT_ID]: Vue.$cookies.get(KEYS.CONTACT_ID) != undefined ? Vue.$cookies.get(KEYS.CONTACT_ID) : '',
    [KEYS.PACKAGE_ID]: Vue.$cookies.get(KEYS.PACKAGE_ID) != undefined ? Vue.$cookies.get(KEYS.PACKAGE_ID) : '',
    [KEYS.PLAN_ID]: Vue.$cookies.get(KEYS.PLAN_ID) != undefined ? Vue.$cookies.get(KEYS.PLAN_ID) : ''
};
export const mutations = {
    CLEAR_DATA(state) {
        Vue.set(state, KEYS.LIGHTBOX_CHECKOUT_TYPE, '');
        Vue.set(state, KEYS.QUOTATION_TOKEN, '');
        Vue.set(state, KEYS.SLOT_ID, '');
        Vue.set(state, KEYS.PLAN_ID, '');

        state[KEYS.LIGHTBOX_CHECKOUT_TYPE] = '';
        state[KEYS.QUOTATION_TOKEN] = '';
        state[KEYS.SLOT_ID] = '';
        state[KEYS.PLAN_ID] = '';

        Vue.$cookies.set(KEYS.LIGHTBOX_CHECKOUT_TYPE, state[KEYS.LIGHTBOX_CHECKOUT_TYPE]);
        Vue.$cookies.set(KEYS.QUOTATION_TOKEN, state[KEYS.QUOTATION_TOKEN]);
        Vue.$cookies.set(KEYS.SLOT_ID, state[KEYS.SLOT_ID]);
        Vue.$cookies.set(KEYS.SLOT_ID, state[KEYS.PLAN_ID]);
    },
    SET_FROM_MEETING(state, meetingId) {
        Vue.set(state, KEYS.LIGHTBOX_CHECKOUT_TYPE, LIGHTBOX_CHECKOUT_TYPE.MEETING);
        state[KEYS.LIGHTBOX_CHECKOUT_TYPE] = LIGHTBOX_CHECKOUT_TYPE.MEETING;
        Vue.$cookies.set(KEYS.LIGHTBOX_CHECKOUT_TYPE, LIGHTBOX_CHECKOUT_TYPE.MEETING);

        Vue.set(state, KEYS.MEETING, meetingId);
        state[KEYS.MEETING] = meetingId;
        Vue.$cookies.set(KEYS.MEETING, meetingId);
    },
    SET_PAYMENT_CHECKOUT(state, obj) {
        Vue.set(state, KEYS.LIGHTBOX_CHECKOUT_TYPE, LIGHTBOX_CHECKOUT_TYPE.LEAD);
        Vue.set(state, KEYS.QUOTATION_TOKEN, obj.token);
        Vue.set(state, KEYS.SLOT_ID, obj.competitionId);

        state[KEYS.LIGHTBOX_CHECKOUT_TYPE] = LIGHTBOX_CHECKOUT_TYPE.LEAD;
        state[KEYS.QUOTATION_TOKEN] = obj.token;
        state[KEYS.SLOT_ID] = obj.competitionId;

        Vue.$cookies.set(KEYS.LIGHTBOX_CHECKOUT_TYPE, state[KEYS.LIGHTBOX_CHECKOUT_TYPE]);
        Vue.$cookies.set(KEYS.QUOTATION_TOKEN, state[KEYS.QUOTATION_TOKEN]);
        Vue.$cookies.set(KEYS.SLOT_ID, state[KEYS.SLOT_ID]);
    },
    SET_FROM_CONTACT_NETWORK(state, contactId) {
        Vue.set(state, KEYS.LIGHTBOX_CHECKOUT_TYPE, LIGHTBOX_CHECKOUT_TYPE.CONTACT);
        state[KEYS.CONTACT_ID] = contactId;
        Vue.$cookies.set(KEYS.CONTACT_ID, contactId);
    },
    SET_PACKAGE_ID(state, id) {
        Vue.set(state, KEYS.PACKAGE_ID, id);
        state[KEYS.PACKAGE_ID] = id;
        Vue.$cookies.set(KEYS.PACKAGE_ID, id);

        Vue.set(state, KEYS.LIGHTBOX_CHECKOUT_TYPE, LIGHTBOX_CHECKOUT_TYPE.BALANCE);
        state[KEYS.LIGHTBOX_CHECKOUT_TYPE] = LIGHTBOX_CHECKOUT_TYPE.BALANCE;
        Vue.$cookies.set(KEYS.LIGHTBOX_CHECKOUT_TYPE, LIGHTBOX_CHECKOUT_TYPE.BALANCE);
    },
    SET_PLAN_ID(state, id) {
        Vue.set(state, KEYS.PLAN_ID, id);
        state[KEYS.PLAN_ID] = id;
        Vue.$cookies.set(KEYS.PLAN_ID, id);

        Vue.set(state, KEYS.LIGHTBOX_CHECKOUT_TYPE, LIGHTBOX_CHECKOUT_TYPE.SUBSCRIPTION);
        state[KEYS.LIGHTBOX_CHECKOUT_TYPE] = LIGHTBOX_CHECKOUT_TYPE.SUBSCRIPTION;
        Vue.$cookies.set(KEYS.LIGHTBOX_CHECKOUT_TYPE, LIGHTBOX_CHECKOUT_TYPE.SUBSCRIPTION);
    }
};
export const actions = {
    setPaymentCheckout({ commit }, obj) {
        commit('SET_PAYMENT_CHECKOUT', obj);
    },
    setPlanId({ commit }, obj) {
        commit('SET_PLAN_ID', obj);
    },
    setFromMeetingCheckout({ commit }, meetingId) {
        commit('SET_FROM_MEETING', meetingId);
    },
    clearData({ commit }) {
        commit('CLEAR_DATA');
    },
    setContactNetwork({ commit }, contactId) {
        commit('SET_FROM_CONTACT_NETWORK', contactId);
    },
    setPackageId({ commit }, id) {
        commit('SET_PACKAGE_ID', id);
    }
};
